/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.downtime.controllers', [])

.controller('DowntimeController', ['$scope', function($scope) {

    $scope.downtime = {

      model: "Your spankin new downtime view!",

      init: function() {},

      success: {
        init: function(response) {}
      },

      error: {
        init: function(response) {}
      }

    };

    $scope.downtime.init();

}]);